import { createReducer, on } from '@ngrx/store';

import {
  BuildingItem,
  buildingsAdapter,
  initialStateBuildings,
} from '@store/buildings/buildinngs.state';

import {
  addBuilding,
  addRoom,
  deleteBuilding,
  deleteRoom,
  loadBuildings,
  loadBuildingsFailure,
  loadBuildingsSuccess,
  setLastPageStateBuildings,
  updateBuilding,
  updateRoom,
} from './buildings.actions';

export const buildingsReducer = createReducer(
  initialStateBuildings,
  on(loadBuildings, (state) => ({
    ...state,
    loading: true,
    error: undefined,
  })),

  on(loadBuildingsSuccess, (state, { list }) =>
    buildingsAdapter.setAll(list, {
      ...state,
      loading: false,
    }),
  ),

  on(loadBuildingsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(setLastPageStateBuildings, (state, { newPageState }) => {
    return {
      ...state,
      lastPageState: {
        ...state.lastPageState,
        ...newPageState,
      },
    };
  }),

  on(addBuilding, (state, { building }) => buildingsAdapter.addOne(building, state)),

  on(updateBuilding, (state, { id, changes }) =>
    buildingsAdapter.updateOne({ id: +id, changes }, state),
  ),

  on(deleteBuilding, (state, { id }) => buildingsAdapter.removeOne(+id, state)),

  on(updateRoom, (state, { changes }) => {
    const buildingId = changes.building;

    if (!buildingId) {
      return state;
    }

    const building = state.entities[buildingId];

    if (!building) {
      return state;
    }

    return {
      ...state,
      entities: {
        ...state.entities,
        [buildingId]: {
          ...building,
          rooms: building.rooms.map((rooms) =>
            rooms.id === changes.id ? { ...rooms, ...changes } : rooms,
          ),
        },
      },
    };
  }),

  on(addRoom, (state, { changes }) => {
    const buildingId = changes.building;

    if (!buildingId) {
      return state;
    }

    const building: BuildingItem | undefined = state.entities[buildingId];

    if (!building) {
      return state;
    }

    return {
      ...state,
      entities: {
        ...state.entities,
        [buildingId]: {
          ...building,
          rooms: [...building.rooms, changes],
        },
      },
    };
  }),

  on(deleteRoom, (state, { id, buildingId }) => {
    const building = state.entities[buildingId];
    if (!building) {
      return state;
    }

    return {
      ...state,
      entities: {
        ...state.entities,
        [buildingId]: {
          ...building,
          rooms: building.rooms.filter((room) => room.id !== id),
        },
      },
    };
  }),
);
